import {useMutation, UseMutationResult, useQueryClient} from "@tanstack/react-query";
import {
    IVoceSchedaCosto
} from "../../../../../../../../utils/interfaces/tannery_production/order_schedule/schede_costo/IVoceSchedaCosto";
import {CustomAxiosError, useApiCalls} from "../../../../../../../../logics/api_config";
import {useAuth} from "../../../../../../../../utils/contexts/auth-context";


const useApiUpdateVoceSchedaCosto = (scheda_costo_id: number | undefined): UseMutationResult<IVoceSchedaCosto, CustomAxiosError, {
    id: number;
    data: any
}, unknown> => {
    const queryClient = useQueryClient();
    const {selectedCompany} = useAuth()

    const {put} = useApiCalls()


    async function doUpdate(company_token: string | undefined,
                            pk: number | undefined,
                            data: any): Promise<IVoceSchedaCosto> {
        try {
            const response = await put(`/api/company/${company_token}/tannery_production/schede_costo/schede_costo/${scheda_costo_id}/voci_scheda_costo/${pk}/`, data);
            return response.data as IVoceSchedaCosto;
        } catch (error) {
            throw error;
        }
    }

    return useMutation<IVoceSchedaCosto, CustomAxiosError, {
        id: number;
        data: any
    }, unknown>({
        mutationFn: async ({id, data}) => {
            return await doUpdate(selectedCompany?.company_token, id, data);
        },
        onSuccess: async (data) => {
            await queryClient.invalidateQueries({queryKey: ['useApiGetVoceSchedaCostoDetail', scheda_costo_id, data.id]});
            await queryClient.invalidateQueries({queryKey: ['useApiGetVociSchedaCosto', scheda_costo_id]});
        },
    });
};


export default useApiUpdateVoceSchedaCosto;